import * as Scrivito from "scrivito";
import I18n from "^/config/i18n";

import ImageOrVideo from "^/Components/ImageOrVideo";
import { formatDateRange } from "^/utils/formatDateRange";

// Helper: remove HTML tags and limit length
const getShortDescription = (html, maxLength = 300) => {
  if (!html) return "";

  // Remove HTML tags
  const text = html
    .replace(/<[^>]*>/g, "")
    .replace(/\s+/g, " ")
    .trim();

  if (text.length <= maxLength) return text;

  // Cut to maxLength
  const truncated = text.slice(0, maxLength);

  // Find last whitespace within the limit
  const lastSpaceIndex = truncated.lastIndexOf(" ");

  // If no space found (very long single word), fall back to hard cut
  const safeCut =
    lastSpaceIndex > 0 ? truncated.slice(0, lastSpaceIndex) : truncated;

  return `${safeCut.trimEnd()}…`;
};

export const Event = Scrivito.connect(({ event, className = "" }) => {
  const description = getShortDescription(
    event.get("shortDescription") || event.get("description"),
    300
  );

  return (
    <Scrivito.LinkTag to={event} className={`teaser-side-bar ${className}`}>
      <div className="teaser-side-bar__header">
        <ImageOrVideo widget={event} teaser={true} lazy={true} />
        <div className="teaser-side-bar__date">
          {formatDateRange(event.get("date"), event.get("endDate"), {
            locale: event.language() || "de",
            allDay: event.get("allDay"),
          })}
        </div>
      </div>
      <h6 className="teaser-side-bar__title">{event.get("title")}</h6>
      <div className="m-0 teaser-side-bar__description">{description}</div>
      <span className="teaser-box__button">
        <i className="las la-angle-right me-2"></i>
        {I18n.t("Event to event")}
      </span>
    </Scrivito.LinkTag>
  );
});

export const EventList = Scrivito.connect(({ list, headline }) => {
  if (list.length === 0) {
    return null;
  }
  return (
    <>
      <h4 className="event-header mt-5">{headline}</h4>
      <div>
        {list.map((event, index) => (
          <Event event={event} key={index} />
        ))}
      </div>
    </>
  );
});
